import '@ssml-editor/core';
import { MenuBaseService, EditorUtils } from '@ssml-editor/vue';
import { Alphabet } from '../../module/phoneme/alphabet.enum.js';
import { PHONEME_TYPE } from '../../module/phoneme/constant.js';
import { SAY_AS_TYPE } from '../../module/say-as/constant.js';
import { SayAsInterpretation } from '../../module/say-as/say-as-interpretation.enum.js';
import '@ssml-editor/modules';
import { SPEAK_TYPE } from '../../module/speak/constant.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { R as Range } from '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/index-B_A1dZu-.js';
import { SUB_TYPE } from '../../module/sub/constant.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import { Warning } from '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import './constant.js';
/* empty css                */
import { ValidatorUtils } from './validator-utils.js';
import '@element-plus/icons-vue';
/* empty css                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                       */
/* empty css                         */
/* empty css                     */
/* empty css                                  */
/* empty css                             */
/* empty css                         */
import '../voice/voice-menu.vue.js';

class SayAsMenuService extends MenuBaseService {
  isDisabled() {
    if (super.isDisabled()) return true;
    const { selection } = this.editor;
    if (!selection) return true;
    if (Range.isCollapsed(selection)) {
      throw new Warning("请框选要添加读法的文本");
    }
    const speakNode = EditorUtils.findSelectedNodeByType(
      this.editor,
      SPEAK_TYPE
    );
    if (!speakNode) {
      throw new Warning("请先为段落添加属性");
    }
    const subNode = EditorUtils.findSelectedNodeByType(this.editor, SUB_TYPE);
    if (subNode) {
      throw new Warning("已添加别名的文本无法添加读法");
    }
    const phonemeNode = EditorUtils.findSelectedNodeByType(
      this.editor,
      PHONEME_TYPE
    );
    if (phonemeNode) {
      const alphabet = phonemeNode.alphabet;
      if (alphabet === Alphabet.PY) {
        throw new Warning("已添加拼音的文本无法添加读法");
      } else {
        throw new Warning("已添加音标的文本无法添加读法");
      }
    }
    return false;
  }
  getDefaultValidateMethod(key) {
    switch (key) {
      case SayAsInterpretation.CARDINAL:
        return ValidatorUtils.isCardinal.bind(ValidatorUtils);
      case SayAsInterpretation.DIGITS:
        return ValidatorUtils.isDigits.bind(ValidatorUtils);
      case SayAsInterpretation.TELEPHONE:
        return ValidatorUtils.isTelephone.bind(ValidatorUtils);
      case SayAsInterpretation.NAME:
        return ValidatorUtils.isName.bind(ValidatorUtils);
      case SayAsInterpretation.ADDRESS:
        return ValidatorUtils.isAddress.bind(ValidatorUtils);
      case SayAsInterpretation.ID:
        return ValidatorUtils.isId.bind(ValidatorUtils);
      case SayAsInterpretation.CHARACTERS:
        return ValidatorUtils.isCharacters.bind(ValidatorUtils);
      case SayAsInterpretation.PUNCTUATION:
        return ValidatorUtils.isPunctuation.bind(ValidatorUtils);
      case SayAsInterpretation.DATE:
        return ValidatorUtils.isDate.bind(ValidatorUtils);
      case SayAsInterpretation.TIME:
        return ValidatorUtils.isTime.bind(ValidatorUtils);
      case SayAsInterpretation.CURRENCY:
        return ValidatorUtils.isCurrency.bind(ValidatorUtils);
      case SayAsInterpretation.MEASURE:
        return ValidatorUtils.isMeasure.bind(ValidatorUtils);
      default:
        return () => false;
    }
  }
  setNode(interpret, mark) {
    if (!this.isDisabled()) {
      const value = this.getText();
      if (value) {
        const element = {
          type: SAY_AS_TYPE,
          interpretAs: interpret,
          mark,
          children: [{ text: value }]
        };
        const node = EditorUtils.findSelectedNodeByType(
          this.editor,
          SAY_AS_TYPE
        );
        if (node) {
          const partialElement = element;
          delete partialElement.children;
          delete partialElement.type;
          EditorUtils.replaceNode(this.editor, node, partialElement);
        } else {
          this.editor.insertNode(element);
        }
      }
    }
  }
}

export { SayAsMenuService };
//# sourceMappingURL=say-as-menu-service.js.map
